import { Record } from "../../fable_modules/fable-library-js.4.18.0/Types.js";
import { getEnumName, enum_type, parseEnum, class_type, float64_type, int64_type, record_type, array_type, int32_type, option_type, string_type } from "../../fable_modules/fable-library-js.4.18.0/Reflection.js";
import { ofSeq, empty } from "../../fable_modules/fable-library-js.4.18.0/Map.js";
import { comparePrimitives } from "../../fable_modules/fable-library-js.4.18.0/Util.js";
import { ofArray } from "../../fable_modules/fable-library-js.4.18.0/List.js";
import { printf, toFail } from "../../fable_modules/fable-library-js.4.18.0/String.js";

export class QueryResultSet$1 extends Record {
    constructor(ResultSetId, TotalResultCount, FirstResultPage) {
        super();
        this.ResultSetId = ResultSetId;
        this.TotalResultCount = (TotalResultCount | 0);
        this.FirstResultPage = FirstResultPage;
    }
}

export function QueryResultSet$1_$reflection(gen0) {
    return record_type("Loop54.Common.Kpi.Kpi.QueryResultSet`1", [gen0], QueryResultSet$1, () => [["ResultSetId", option_type(string_type)], ["TotalResultCount", int32_type], ["FirstResultPage", array_type(gen0)]]);
}

export class MainKpiResults extends Record {
    constructor(NavigationLabel, NavigationCount, InteractionLabel, InteractionCount, InteractionRate, InteractionPos, InteractionsPerNav, InteractionPrice) {
        super();
        this.NavigationLabel = NavigationLabel;
        this.NavigationCount = NavigationCount;
        this.InteractionLabel = InteractionLabel;
        this.InteractionCount = InteractionCount;
        this.InteractionRate = InteractionRate;
        this.InteractionPos = InteractionPos;
        this.InteractionsPerNav = InteractionsPerNav;
        this.InteractionPrice = InteractionPrice;
    }
}

export function MainKpiResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.MainKpiResults", [], MainKpiResults, () => [["NavigationLabel", string_type], ["NavigationCount", int64_type], ["InteractionLabel", string_type], ["InteractionCount", int64_type], ["InteractionRate", float64_type], ["InteractionPos", float64_type], ["InteractionsPerNav", float64_type], ["InteractionPrice", float64_type]]);
}

export function MainKpiResults_get_Empty() {
    return new MainKpiResults("N/A", 0n, "N/A", 0n, 0, 0, 0, 0);
}

export class ScopedMainKpiResults extends Record {
    constructor(Customer, Storefront, Language, Environment, Split, KpiResults) {
        super();
        this.Customer = Customer;
        this.Storefront = Storefront;
        this.Language = Language;
        this.Environment = Environment;
        this.Split = Split;
        this.KpiResults = KpiResults;
    }
}

export function ScopedMainKpiResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.ScopedMainKpiResults", [], ScopedMainKpiResults, () => [["Customer", class_type("System.Guid")], ["Storefront", class_type("System.Guid")], ["Language", string_type], ["Environment", string_type], ["Split", option_type(string_type)], ["KpiResults", MainKpiResults_$reflection()]]);
}

export class GroupedMainKpiResults extends Record {
    constructor(Main, Revenue) {
        super();
        this.Main = Main;
        this.Revenue = Revenue;
    }
}

export function GroupedMainKpiResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.GroupedMainKpiResults", [], GroupedMainKpiResults, () => [["Main", MainKpiResults_$reflection()], ["Revenue", MainKpiResults_$reflection()]]);
}

export class AllInteractionTypesMainKpiResults extends Record {
    constructor(KpiResults) {
        super();
        this.KpiResults = KpiResults;
    }
}

export function AllInteractionTypesMainKpiResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.AllInteractionTypesMainKpiResults", [], AllInteractionTypesMainKpiResults, () => [["KpiResults", array_type(MainKpiResults_$reflection())]]);
}

export class RequestIdentityFields extends Record {
    constructor(RequestLabel, RequestType) {
        super();
        this.RequestLabel = RequestLabel;
        this.RequestType = RequestType;
    }
}

export function RequestIdentityFields_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.RequestIdentityFields", [], RequestIdentityFields, () => [["RequestLabel", string_type], ["RequestType", string_type]]);
}

export class RequestDisplayFields extends Record {
    constructor(Name, Value, Details) {
        super();
        this.Name = Name;
        this.Value = Value;
        this.Details = Details;
    }
}

export function RequestDisplayFields_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.RequestDisplayFields", [], RequestDisplayFields, () => [["Name", string_type], ["Value", string_type], ["Details", string_type]]);
}

export class CategoryAliasData extends Record {
    constructor(IdentityFields, DisplayFields) {
        super();
        this.IdentityFields = IdentityFields;
        this.DisplayFields = DisplayFields;
    }
}

export function CategoryAliasData_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.CategoryAliasData", [], CategoryAliasData, () => [["IdentityFields", RequestIdentityFields_$reflection()], ["DisplayFields", RequestDisplayFields_$reflection()]]);
}

export class RequestMappedFields extends Record {
    constructor(Title, Url, Price, ImageUrl) {
        super();
        this.Title = Title;
        this.Url = Url;
        this.Price = Price;
        this.ImageUrl = ImageUrl;
    }
}

export function RequestMappedFields_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.RequestMappedFields", [], RequestMappedFields, () => [["Title", option_type(string_type)], ["Url", option_type(string_type)], ["Price", option_type(float64_type)], ["ImageUrl", option_type(string_type)]]);
}

export class TrendingValuesResults extends Record {
    constructor(RequestIdentity, RequestDisplay, RequestMapping, Previous, Recent) {
        super();
        this.RequestIdentity = RequestIdentity;
        this.RequestDisplay = RequestDisplay;
        this.RequestMapping = RequestMapping;
        this.Previous = Previous;
        this.Recent = Recent;
    }
}

export function TrendingValuesResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.TrendingValuesResults", [], TrendingValuesResults, () => [["RequestIdentity", RequestIdentityFields_$reflection()], ["RequestDisplay", RequestDisplayFields_$reflection()], ["RequestMapping", RequestMappedFields_$reflection()], ["Previous", int64_type], ["Recent", int64_type]]);
}

export class ProductsWithInteractionsResults extends Record {
    constructor(RequestLabel, Volume, Title, Url, Price, ImageUrl, SessionCount, AllUniqueInteractions, UniqueClicks, UniqueAddToCart, UniquePurchases) {
        super();
        this.RequestLabel = RequestLabel;
        this.Volume = Volume;
        this.Title = Title;
        this.Url = Url;
        this.Price = Price;
        this.ImageUrl = ImageUrl;
        this.SessionCount = SessionCount;
        this.AllUniqueInteractions = AllUniqueInteractions;
        this.UniqueClicks = UniqueClicks;
        this.UniqueAddToCart = UniqueAddToCart;
        this.UniquePurchases = UniquePurchases;
    }
}

export function ProductsWithInteractionsResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.ProductsWithInteractionsResults", [], ProductsWithInteractionsResults, () => [["RequestLabel", string_type], ["Volume", int64_type], ["Title", option_type(string_type)], ["Url", option_type(string_type)], ["Price", option_type(float64_type)], ["ImageUrl", option_type(string_type)], ["SessionCount", int64_type], ["AllUniqueInteractions", int64_type], ["UniqueClicks", int64_type], ["UniqueAddToCart", int64_type], ["UniquePurchases", int64_type]]);
}

export class PerformanceResults extends Record {
    constructor(RequestIdentity, RequestDisplay, RequestMapping, Count, InteractionRate, InteractionPos, InteractionsPerNav, InteractionPrice) {
        super();
        this.RequestIdentity = RequestIdentity;
        this.RequestDisplay = RequestDisplay;
        this.RequestMapping = RequestMapping;
        this.Count = Count;
        this.InteractionRate = InteractionRate;
        this.InteractionPos = InteractionPos;
        this.InteractionsPerNav = InteractionsPerNav;
        this.InteractionPrice = InteractionPrice;
    }
}

export function PerformanceResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.PerformanceResults", [], PerformanceResults, () => [["RequestIdentity", RequestIdentityFields_$reflection()], ["RequestDisplay", RequestDisplayFields_$reflection()], ["RequestMapping", RequestMappedFields_$reflection()], ["Count", int64_type], ["InteractionRate", float64_type], ["InteractionPos", float64_type], ["InteractionsPerNav", float64_type], ["InteractionPrice", float64_type]]);
}

export class Suggestion extends Record {
    constructor(RefinementQuery, RefinementSessionCount, RefinementRate, RefinementPopularity, RefinedIr, RefinedToOriginalIr) {
        super();
        this.RefinementQuery = RefinementQuery;
        this.RefinementSessionCount = RefinementSessionCount;
        this.RefinementRate = RefinementRate;
        this.RefinementPopularity = RefinementPopularity;
        this.RefinedIr = RefinedIr;
        this.RefinedToOriginalIr = RefinedToOriginalIr;
    }
}

export function Suggestion_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.Suggestion", [], Suggestion, () => [["RefinementQuery", string_type], ["RefinementSessionCount", int64_type], ["RefinementRate", float64_type], ["RefinementPopularity", int64_type], ["RefinedIr", float64_type], ["RefinedToOriginalIr", option_type(float64_type)]]);
}

export class RefinementDetail extends Record {
    constructor(OriginalQueryPopularity, OriginalQueryIr, Suggestions) {
        super();
        this.OriginalQueryPopularity = OriginalQueryPopularity;
        this.OriginalQueryIr = OriginalQueryIr;
        this.Suggestions = Suggestions;
    }
}

export function RefinementDetail_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.RefinementDetail", [], RefinementDetail, () => [["OriginalQueryPopularity", int64_type], ["OriginalQueryIr", float64_type], ["Suggestions", array_type(Suggestion_$reflection())]]);
}

export class RefinementResults extends Record {
    constructor(ByQuery) {
        super();
        this.ByQuery = ByQuery;
    }
}

export function RefinementResults_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.RefinementResults", [], RefinementResults, () => [["ByQuery", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, RefinementDetail_$reflection()])]]);
}

export function RefinementResults_get_Empty() {
    return new RefinementResults(empty({
        Compare: comparePrimitives,
    }));
}

export class RefinementParameters extends Record {
    constructor(MinSessions, MinRefinementRate, MinRefinedIr, MinIrRatio) {
        super();
        this.MinSessions = MinSessions;
        this.MinRefinementRate = MinRefinementRate;
        this.MinRefinedIr = MinRefinedIr;
        this.MinIrRatio = MinIrRatio;
    }
}

export function RefinementParameters_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.RefinementParameters", [], RefinementParameters, () => [["MinSessions", option_type(int32_type)], ["MinRefinementRate", option_type(float64_type)], ["MinRefinedIr", option_type(float64_type)], ["MinIrRatio", option_type(float64_type)]]);
}

export class MainKpisPerDay extends Record {
    constructor(Date$, Count, InteractionRate, Aip, Revenue) {
        super();
        this.Date = Date$;
        this.Count = Count;
        this.InteractionRate = InteractionRate;
        this.Aip = Aip;
        this.Revenue = Revenue;
    }
}

export function MainKpisPerDay_$reflection() {
    return record_type("Loop54.Common.Kpi.Kpi.MainKpisPerDay", [], MainKpisPerDay, () => [["Date", class_type("System.DateTime")], ["Count", int64_type], ["InteractionRate", float64_type], ["Aip", float64_type], ["Revenue", float64_type]]);
}

export function interactionTypeFromString(tryValue) {
    return parseEnum(enum_type("Loop54.Common.Kpi.Kpi.InteractionType", int32_type, [["All", 0], ["Click", 1], ["AddToCart", 2], ["Purchase", 3]]), tryValue, true);
}

export const defaultInteractionType = 1;

export const interactionTypeLabels = ofSeq([[0, "All"], [1, "Click"], [2, "Add To Cart"], [3, "Purchase"]], {
    Compare: comparePrimitives,
});

export const interactionTypeQsPairs = ofArray([[1, "click"], [2, "addtocart"], [3, "purchase"]]);

export function interactionTypeToQs(interactionTypeEnumValue) {
    switch (interactionTypeEnumValue) {
        case 1:
            return "click";
        case 2:
            return "addtocart";
        case 3:
            return "purchase";
        default:
            return toFail(printf("Unexpected %s value: %A"))("InteractionType")(interactionTypeEnumValue);
    }
}

export function interactionTypeQsToEnum(interactionTypeStr) {
    const matchValue = interactionTypeStr.toLocaleLowerCase();
    switch (matchValue) {
        case "click":
            return 1;
        case "addtocart":
            return 2;
        case "purchase":
            return 3;
        default:
            return undefined;
    }
}

export function matchTypeFromString(tryValue) {
    return parseEnum(enum_type("Loop54.Common.Kpi.Kpi.MatchType", int32_type, [["Exact", 0], ["Contain", 1], ["NotContain", 2], ["StartWith", 3], ["EndWith", 4], ["Regex", 5]]), tryValue, true);
}

export function matchTypeToString(tryValue) {
    return getEnumName(enum_type("Loop54.Common.Kpi.Kpi.MatchType", int32_type, [["Exact", 0], ["Contain", 1], ["NotContain", 2], ["StartWith", 3], ["EndWith", 4], ["Regex", 5]]), tryValue);
}

export const defaultMatchType = 1;

export const matchTypeLabels = ofSeq([[0, "Exact"], [1, "Contains"], [2, "Doesn\'t Contain"], [3, "Starts With"], [4, "Ends With"], [5, "Regex"]], {
    Compare: comparePrimitives,
});

